module.exports = __webpack_public_path__ + "static/liva-pastacilik-case-study-5-9ffa98680e236cecb1141f026440ea1d.png";